const rewards = [
	{
		"velocityPoints" : "5,000-7,799",
		"rewards": [
			{
				"originatingPlace": "Adelaide",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Melbourne",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]

			},
			{
				"originatingPlace": "Brisbane",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Sydney",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Cairns",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					},
					{
							"assetPath": "",
							"quantity": "$20",
							"class": "iTunes",
							"type": "Gift Card",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "For use in iTunes store only.",
							"shortTerms": "For voucher terms and conditions, see <a href='https://www.apple.com/au/shop/gift-cards' target='_blank'>Apple’s website.</a>"
					}

				]
			},
			{
				"originatingPlace": "Canberra",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Gold Coast",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Darwin",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					},
					{
							"assetPath": "",
							"quantity": "$20",
							"class": "iTunes",
							"type": "Gift Card",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "For use in iTunes store only.",
							"shortTerms": "For voucher terms and conditions, see <a href='https://www.apple.com/au/shop/gift-cards' target='_blank'>Apple’s website.</a>"
					}
				]
			},
			{
				"originatingPlace": "Hobart",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Melbourne",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Melbourne",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Sydney",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Perth",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Geraldton",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Sydney",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Gold Coast",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			}
		]
	},
	{
		"velocityPoints" : "7,800-17,999",
		"rewards": [
			{
				"originatingPlace": "Adelaide",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Melbourne",
							"airTaxes": "$23.50",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Sydney",
							"airTaxes": "$22.81",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Brisbane",
							"airTaxes": "$23.18",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Brisbane",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Sydney",
							"airTaxes": "$20.79",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Adelaide",
							"airTaxes": "$23.18",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Melbourne",
							"airTaxes": "$21.47",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Cairns",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Brisbane",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "$40 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$50 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Canberra",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Gold Coast",
							"airTaxes": "$28.91",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Melbourne",
							"airTaxes": "$31.31",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
						    "assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Adelaide",
							"airTaxes": "$33.01",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]

			},
			{
				"originatingPlace": "Darwin",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Alice Springs",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "$40 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					},
					 {
							"assetPath": "",
							"quantity": "$50 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Hobart",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Melbourne",
							"airTaxes": "$17.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Sydney",
							"airTaxes": "$16.95",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Adelaide",
							"airTaxes": "$37.00",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Melbourne",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Sydney",
							"airTaxes": "$21.11",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Hobart",
							"airTaxes": "$17.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Adelaide",
							"airTaxes": "$23.50",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Perth",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Geraldton",
							"airTaxes": "$37.14",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Broome",
							"airTaxes": "$23.88",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "$50 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{

				"originatingPlace": "Sydney",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Gold Coast",
							"airTaxes": "$18.71",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Melbourne",
							"airTaxes": "$21.11",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Brisbane",
							"airTaxes": "$20.79",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			}
		]
	},
	{
		"velocityPoints" : "18,000-44,999",
		"rewards": [
			{
				"originatingPlace": "Adelaide",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Gold Coast",
							"airTaxes": "$21.10",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Adelaide",
							"destination": "Sydney",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Brisbane",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Melbourne",
							"airTaxes": "$21.47",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Brisbane",
							"destination": "Cairns",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Cairns",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Brisbane",
							"airTaxes": "$28.45",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Cairns",
							"destination": "Brisbane",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Canberra",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Gold Coast",
							"airTaxes": "$28.91",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Canberra",
							"destination": "Adelaide",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]

			},
			{
				"originatingPlace": "Darwin",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Alice Springs",
							"airTaxes": "$40.90",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Darwin",
							"destination": "Alice Springs",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Hobart",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Melbourne",
							"airTaxes": "$17.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Hobart",
							"destination": "Sydney",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Melbourne",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Gold Coast",
							"airTaxes": "$19.39",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Melbourne",
							"destination": "Brisbane",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Perth",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Broome",
							"airTaxes": "$23.88",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Perth",
							"destination": "Broome",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{

				"originatingPlace": "Sydney",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Gold Coast",
							"airTaxes": "$18.71",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Sydney",
							"destination": "Fiji",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			}
		]
	},
	{
		"velocityPoints" : "45,000-89,999",
		"rewards": [
			{
				"originatingPlace": "Adelaide",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Perth",
							"airTaxes": "$19.86",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Adelaide",
							"destination": "Gold Coast",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Brisbane",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Fiji",
							"airTaxes": "$82.45",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Brisbane",
							"destination": "Fiji",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Cairns",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Sydney",
							"airTaxes": "$28.08",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Auckland",
							"airTaxes": "$138.81",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Canberra",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Los Angeles",
							"airTaxes": "$133.86",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Auckland",
							"airTaxes": "$145.96",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]

			},
			{
				"originatingPlace": "Darwin",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Sydney",
							"airTaxes": "$30.58",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Melbourne",
							"airTaxes": "$31.26",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Hobart",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Sunshine Coast",
							"airTaxes": "$37.46",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Hobart",
							"destination": "Brisbane",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Melbourne",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Los Angeles",
							"airTaxes": "$120.37",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Melbourne",
							"destination": "Auckland",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{
				"originatingPlace": "Perth",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Sydney",
							"airTaxes": "$17.47",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Perth",
							"destination": "Melbourne",
							"airTaxes": "$18.15",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			},
			{

				"originatingPlace": "Sydney",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Los Angeles",
							"airTaxes": "$106.02",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Sydney",
							"destination": "Fiji",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					},
					{
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}
				]
			}
		]
	},
	{
		"velocityPoints" : "90,000-179,999",
		"rewards": [
			{
				"originatingPlace": "Adelaide",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Los Angeles",
							"airTaxes": "$118.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Auckland",
							"airTaxes": "$131.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Sunshine Coast ",
							"airTaxes": "$43.33",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Brisbane",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Los Angeles",
							"airTaxes": "$104.05",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Auckland",
							"airTaxes": "$116.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Las Vegas ",
							"airTaxes": "$117.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Cairns",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Melbourne",
							"airTaxes": "$28.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Sydney",
							"airTaxes": "$28.08",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Las Vegas",
							"airTaxes": "$139.91",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Canberra",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Los Angeles",
							"airTaxes": "$133.86",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Auckland",
							"airTaxes": "$145.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Las Vegas",
							"airTaxes": "$147.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]

			},
			{
				"originatingPlace": "Darwin",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Melbourne",
							"airTaxes": "$31.26",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Sydney",
							"airTaxes": "$30.58",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Hobart",
							"airTaxes": "$44.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Hobart",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Los Angeles",
							"airTaxes": "$113.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Auckland",
							"airTaxes": "$125.73",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Perth",
							"airTaxes": "$31.66",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Melbourne",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Los Angeles",
							"airTaxes": "$120.37",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Auckland",
							"airTaxes": "$113.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Las Vegas ",
							"airTaxes": "$114.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Perth",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Auckland",
							"airTaxes": "$134.10",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Brisbane",
							"airTaxes": "$17.83",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "3",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Fiji",
							"airTaxes": "$100.30",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{

				"originatingPlace": "Sydney",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Los Angeles",
							"airTaxes": "$106.02",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Auckland",
							"airTaxes": "$118.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Las Vegas",
							"airTaxes": "$119.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			}
		]
	},
	{
		"velocityPoints" : "180,000-359,999",
		"rewards": [
			{
				"originatingPlace": "Adelaide",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Los Angeles",
							"airTaxes": "$118.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Auckland",
							"airTaxes": "$131.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Sunshine Coast ",
							"airTaxes": "$43.33",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Brisbane",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Los Angeles",
							"airTaxes": "$104.05",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Auckland",
							"airTaxes": "$116.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Las Vegas ",
							"airTaxes": "$117.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Cairns",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Melbourne",
							"airTaxes": "$28.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Sydney",
							"airTaxes": "$28.08",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Las Vegas",
							"airTaxes": "$139.91",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Canberra",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Los Angeles",
							"airTaxes": "$133.86",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Auckland",
							"airTaxes": "$145.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Las Vegas",
							"airTaxes": "$147.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]

			},
			{
				"originatingPlace": "Darwin",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Melbourne",
							"airTaxes": "$31.26",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Sydney",
							"airTaxes": "$30.58",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Hobart",
							"airTaxes": "$44.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Hobart",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Los Angeles",
							"airTaxes": "$113.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Auckland",
							"airTaxes": "$125.73",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Perth",
							"airTaxes": "$31.66",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Melbourne",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Los Angeles",
							"airTaxes": "$120.37",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Auckland",
							"airTaxes": "$113.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Las Vegas ",
							"airTaxes": "$114.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Perth",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Auckland",
							"airTaxes": "$134.10",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Brisbane",
							"airTaxes": "$17.83",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "6",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Fiji",
							"airTaxes": "$100.30",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{

				"originatingPlace": "Sydney",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Los Angeles",
							"airTaxes": "$106.02",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Auckland",
							"airTaxes": "$118.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Las Vegas",
							"airTaxes": "$119.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			}
		]
	},
	{
		"velocityPoints" : "360,000-719,999",
		"rewards": [
			{
				"originatingPlace": "Adelaide",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Los Angeles",
							"airTaxes": "$118.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Auckland",
							"airTaxes": "$131.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Sunshine Coast ",
							"airTaxes": "$43.33",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Brisbane",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Los Angeles",
							"airTaxes": "$104.05",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Auckland",
							"airTaxes": "$116.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Las Vegas ",
							"airTaxes": "$117.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Cairns",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Melbourne",
							"airTaxes": "$28.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Sydney",
							"airTaxes": "$28.08",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Las Vegas",
							"airTaxes": "$139.91",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Canberra",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Los Angeles",
							"airTaxes": "$133.86",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Auckland",
							"airTaxes": "$145.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Las Vegas",
							"airTaxes": "$147.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]

			},
			{
				"originatingPlace": "Darwin",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Melbourne",
							"airTaxes": "$31.26",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Sydney",
							"airTaxes": "$30.58",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Hobart",
							"airTaxes": "$44.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Hobart",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Los Angeles",
							"airTaxes": "$113.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Auckland",
							"airTaxes": "$125.73",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Perth",
							"airTaxes": "$31.66",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Melbourne",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Los Angeles",
							"airTaxes": "$120.37",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Auckland",
							"airTaxes": "$113.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Las Vegas ",
							"airTaxes": "$114.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Perth",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Auckland",
							"airTaxes": "$134.10",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Brisbane",
							"airTaxes": "$17.83",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "12",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Fiji",
							"airTaxes": "$100.30",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{

				"originatingPlace": "Sydney",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Los Angeles",
							"airTaxes": "$106.02",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Auckland",
							"airTaxes": "$118.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Las Vegas",
							"airTaxes": "$119.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			}
		]
	},
	{
		"velocityPoints" : ">720,000",
		"rewards": [
			{
				"originatingPlace": "Adelaide",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Los Angeles",
							"airTaxes": "$118.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Auckland",
							"airTaxes": "$131.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Sunshine Coast ",
							"airTaxes": "$43.33",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Brisbane",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Los Angeles",
							"airTaxes": "$104.05",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Auckland",
							"airTaxes": "$116.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Las Vegas ",
							"airTaxes": "$117.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Cairns",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Melbourne",
							"airTaxes": "$28.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Sydney",
							"airTaxes": "$28.08",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Las Vegas",
							"airTaxes": "$139.91",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Canberra",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Los Angeles",
							"airTaxes": "$133.86",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "32",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Auckland",
							"airTaxes": "$145.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Las Vegas",
							"airTaxes": "$147.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]

			},
			{
				"originatingPlace": "Darwin",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "32",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Melbourne",
							"airTaxes": "$31.26",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Sydney",
							"airTaxes": "$30.58",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Hobart",
							"airTaxes": "$44.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Hobart",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Los Angeles",
							"airTaxes": "$113.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "32",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Auckland",
							"airTaxes": "$125.73",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Perth",
							"airTaxes": "$31.66",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Melbourne",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Los Angeles",
							"airTaxes": "$120.37",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Auckland",
							"airTaxes": "$113.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Las Vegas ",
							"airTaxes": "$114.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{
				"originatingPlace": "Perth",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "32",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Auckland",
							"airTaxes": "$134.10",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Brisbane",
							"airTaxes": "$17.83",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "24",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Fiji",
							"airTaxes": "$100.30",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			},
			{

				"originatingPlace": "Sydney",
				"displayOptions": [
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Los Angeles",
							"airTaxes": "$106.02",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Auckland",
							"airTaxes": "$118.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					},
					{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Las Vegas",
							"airTaxes": "$119.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}
				]
			}
		]
	}
]
export default rewards



// WEBPACK FOOTER //
// ./components/calculate-my-bonus/rewards.js